import { FamilyUnit } from '@zorro/clients';
import {
  CoupleIcon,
  FullFamilyIcon,
  ParentWithChildrenIcon,
  SoloPersonIcon,
} from '@zorro/shared/assets';
import { $enum } from 'ts-enum-util';

export const getPersonalizedAllowanceRowConfig = (familyUnit: FamilyUnit) => {
  return $enum.mapValue(familyUnit).with({
    [FamilyUnit.EMPLOYEE_ONLY]: {
      icon: <SoloPersonIcon />,
      label: 'You',
    },
    [FamilyUnit.EMPLOYEE_SPOUSE]: {
      icon: <CoupleIcon />,
      label: 'You + spouse',
    },
    [FamilyUnit.EMPLOYEE_CHILD]: {
      icon: <ParentWithChildrenIcon />,
      label: 'You + child(ren)',
    },
    [FamilyUnit.FAMILY]: {
      icon: <FullFamilyIcon />,
      label: 'Your family',
    },
  });
};
